const apiUrl = process.env.REACT_APP_API_URL;
export const PutProjectesIdAlumnesIdTascaIdComentaris = async ( id_alumne : string, id_projecte : string, id_tasca : number,
                                             observ : string, id_grup : string) => {

    try {
        const response =
                await fetch(`${apiUrl}:8061/projectes/${id_projecte}/grups/${id_grup}/tasca/${id_tasca}/comentari`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                observacio: observ,
                id_alumne: id_alumne
            })
        });
            const jsonData = await response.json();
            return jsonData;

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
